/**
 * Created by vladislav on 4/2/2024
 */

const AdsDetector = function () {
    let PluginClass = NoAdsPlugin;

    const types = [
        typeof MultiAdsPlugin !== "undefined" && MultiAdsPlugin,
        typeof GDComAds !== "undefined" && GDComAds,
        typeof CrazyAds !== "undefined" && CrazyAds,
        typeof PlingaAds !== "undefined" && PlingaAds,
        typeof YandexAppAds !== "undefined" && YandexAppAds,
        typeof AppLovinAds !== "undefined" && AppLovinAds,
        typeof AdMobAds !== "undefined" && AdMobAds,
        typeof OKAds !== "undefined" && OKAds,
        typeof OKBridgeAds !== "undefined" && OKBridgeAds,
        typeof VKAds !== "undefined" && VKAds,
        typeof InstantAds !== "undefined" && InstantAds,
        typeof PortalYandexAds !== "undefined" && PortalYandexAds,
        typeof YandexWebAds !== "undefined" && YandexWebAds,
        typeof CleverAppsGoogleAds !== "undefined" && CleverAppsGoogleAds,
        typeof XiaomiAds !== "undefined" && XiaomiAds,
        typeof GoogleWebAds !== "undefined" && GoogleWebAds,
        typeof AddictingGamesAds !== "undefined" && AddictingGamesAds,
        typeof YoutubeAds !== "undefined" && YoutubeAds,
        typeof GameSnackAds !== "undefined" && GameSnackAds,
        typeof YandexAds !== "undefined" && YandexAds,
        typeof MSStartAds !== "undefined" && MSStartAds,
        typeof G5WindowsAds !== "undefined" && G5WindowsAds,
        typeof SamsungAds !== "undefined" && SamsungAds,
        typeof WechatAds !== "undefined" && WechatAds,
        typeof TikTokAds !== "undefined" && TikTokAds,
        typeof ArkadiumAds !== "undefined" && ArkadiumAds,
        typeof VideoAds !== "undefined" && VideoAds
    ];

    for (let i = 0; i < types.length; i++) {
        if (types[i] && types[i].isAppropriate()) {
            PluginClass = types[i];
            break;
        }
    }

    return PluginClass;
};